import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
export const EText = (props) => {
    return _jsx(Typography, { ...props, fontFamily: '"SuisseIntl"' });
};
